import { Action, createReducer, on } from '@ngrx/store';
import { cacheHttpCall } from '../actions/cache.action';
import { CacheState, initialCacheState } from '../types/cache.state';

function cacheHttpCallReducer(state: CacheState, props: { url: string; response: unknown }): CacheState {
    return {
        ...state,
        [props.url]: props.response,
    };
}

const createCacheReducer = createReducer(initialCacheState, on(cacheHttpCall, cacheHttpCallReducer));

export function cacheReducer(state: Readonly<CacheState>, action: Action): Readonly<CacheState> {
    return createCacheReducer(state, action);
}
